import { PropsWithChildren, useEffect, useState } from "react";
import FlowingWaves from "./floating-waves";

const FloatingWaveLayout = ({ children }: PropsWithChildren) => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  return (
    <div className="w-full h-full relative">
      <FlowingWaves scrollY={scrollY} />
      <div className="relative z-10 h-full">{children}</div>
    </div>
  );
};
export default FloatingWaveLayout;
